import { render, staticRenderFns } from "./usersOpeningBalance.vue?vue&type=template&id=66f7ee11&scoped=true"
import script from "./usersOpeningBalance.vue?vue&type=script&lang=js"
export * from "./usersOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./usersOpeningBalance.vue?vue&type=style&index=0&id=66f7ee11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f7ee11",
  null
  
)

export default component.exports